<template>
  <div>
    <div class="sticky" v-if="sticky" v-show="!isMobile">
      <table :class="{'table-loading':loading}">
        <thead>
          <th>Name</th>
          <th>Username</th>
          <th>Email</th>
          <th>Mobile</th>
          <th>Active</th>
          <th></th>
        </thead>
        <tbody>
          <tr v-for="admin in admins" v-if="admins.length">
            <td>{{ admin.firstName + ' ' + admin.lastName }}</td>
            <td>{{ admin.username }}</td>
            <td>{{ admin.email }}</td>
            <td>{{ admin.mobile }}</td>
            <td>
              <div :class="{'slider':true, 'active':admin.isActive, 'disabled':false}"
                @click="updateStatus(admin.id, admin.isActive)"></div>
            </td>
            <td>
              <button class="button cta xsmall" @click="edit(admin.id)">EDIT</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <table :class="{'table-loading':loading}" v-if="!isMobile">
      <thead>
        <th>Name</th>
        <th>Username</th>
        <th>Email</th>
        <th>Mobile</th>
        <th>Active</th>
        <th></th>
      </thead>
      <tbody>
        <tr v-for="admin in admins" v-if="admins.length">
          <td>{{ admin.firstName + ' ' + admin.lastName }}</td>
          <td>{{ admin.username }}</td>
          <td>{{ admin.email }}</td>
          <td>{{ admin.mobile }}</td>
          <td>
            <div :class="{'slider':true, 'active':admin.isActive, 'disabled':sliderLoader.indexOf(admin.id) > -1}"
              @click="updateStatus(admin.id, admin.isActive)"></div>
          </td>
          <td>
            <button class="button cta xsmall" @click="edit(admin.id)" v-if="admin.isActive">EDIT</button>
          </td>
        </tr>

        <tr v-show="loading && !admins.length">
          <td class="table-block" colspan="27">
            <transition name="slide-up">
              <div class="loader" v-show="loading">
                <div>
                  <i class="fas fa-spinner fa-spin"></i>
                  Loading...
                </div>
              </div>
            </transition>
          </td>
        </tr>

        <tr v-show="!loading && !admins.length">
          <td class="table-block" colspan="27">
            <i class="far fa-frown-open fa-3x"></i>
            <div>No results</div>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else>
      <div v-if="loading && !admins.length" class="loading">
        <h2><i class="fas fa-spinner fa-spin"></i> Loading...</h2>
      </div>
      <div v-else class="card-holder">
        <div class="cards" v-for="(admin, i) in admins" :key="i">
          <div class="card">
            <div class="card-header">
              <div :class="{'slider':true, 'active':admin.isActive, 'disabled':sliderLoader.indexOf(admin.id) > -1}"
              @click="updateStatus(admin.id, admin.isActive)"></div>
              <div @click="edit(admin.id)" v-if="admin.isActive">
                <i class="fas fa-user-edit"></i>
              </div>
            </div>
            <div class="title">
              <span class="label">Name:</span>
              <div class="value">{{admin.firstName + ' ' + admin.lastName}}</div>
            </div>
            <div class="title">
              <span class="label">Username:</span>
              <div class="value">{{ admin.username }}</div>
            </div>
            <div class="title">
              <span class="label">Email:</span>
              <div class="value">{{ admin.email }}</div>
            </div>
            <div class="title">
              <span class="label">Mobile:</span>
              <div class="value">{{admin.mobile}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'op--modal-container':true, 'hide':!showConfirm}" @click="close(false)">
      <div class="op--modal">
        <div class="op--modal-content" >
          <div class="delete-box" @click.stop>
            <div v-if="deleteConfirm">
              <span>Are you sure you want to delete this admin?</span>
              <div :class="{'button cta warning':true, 'disabled':deleteLoading}" @click="close(false)">No</div>
              <div :class="{'button cta':true, 'disabled':deleteLoading}" @click="confirmDelete">Yes</div>
            </div>
            <div v-else>
              <transition name="slide-up">
                <i class="far fa-check-circle fa-4x" v-show="showConfirm"></i>
              </transition>
              <span>Successfully deleted admin.</span>
              <div class="button cta success" @click="close(true)">Close</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ApiAdmin from '@/modules/api/admin'

export default {
  name: 'admin-list',
  components: {},
  data () {
    return {
      tab: 0,
      showConfirm: false,
      deleteConfirm: true,
      deleteLoading: false,
      deleteID: 0,
      sticky: false,
      sliderLoader: [],
      isMobile: false
    }
  },
  computed: {
    admins () { return this.$store.state.admin.list },
    loading () { return this.$store.state.admin.loading },
    _addSuccess () { return this.$store.state.admin.addSuccess }
  },
  methods: {
    getAdmins () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('admin/setLoading', true)
      ApiAdmin.getAdmins(self, {}, function (res) {
        self.$store.commit('admin/setLoading', false)
        self.$nextTick(() => { self.getDimensions() })
      })
    },
    edit (id) {
      let index = this.admins.findIndex(x => x.id === id)
      this.$store.commit('admin/setEdit', this.admins[index])
      this.$store.commit('admin/setShowForm', true)
    },
    getDimensions () {
      // let self = this
      // for (let key in self.dimension) {
      //   self.dimension[key] = self.$refs[key].clientWidth
      // }
    },
    close (refreshPage) {
      if (this.loading) { return }
      this.deleteID = 0
      this.showConfirm = false
      if (refreshPage) {
        this.getAdmins()
      }
    },
    deleteAdmin (id) {
      this.deleteID = id
      this.deleteConfirm = true
      this.showConfirm = true
    },
    confirmDelete () {
      let self = this
      self.deleteLoading = true
      ApiAdmin.deleteAdmin(self, self.deleteID, function (res) {
        self.deleteConfirm = false
        self.deleteLoading = false
      })
    },
    updateStatus (id, deactivate) {
      let self = this
      self.sliderLoader.push(id)
      ApiAdmin.updateStatus(self, {id: id, deactivate: deactivate}, function (res) {
        let index = self.sliderLoader.indexOf(id)
        self.sliderLoader.splice(index, 1)
        if (!res.error) {
          self.$store.commit('admin/updateAdminActive', {id: id, isActive: !deactivate})
        }
      })
    },
    onScroll () { this.sticky = window.pageYOffset > 141 },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  watch: {
    _addSuccess: function (value) {
      if (value) {
        this.getAdmins()
        this.$store.commit('admin/setAddSuccess', false)
      }
    },
  },
  mounted () {
    let self = this
    self.getAdmins()

    // self.onScroll()
    window.onscroll = function () { self.onScroll() }
    self.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>
table{
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 60px;

  &.table-loading{
    opacity: .7;
  }
  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{
      padding: 5px;
      border-right: 1px solid #ccc;
      &:last-child{ border-right: none; }
    }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      &:hover { background: #e3e7e8!important; }
      &:nth-of-type(even) { background: #fcfcfc; }
      td{
        padding: 5px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;
        border-right: 1px solid #ccc;

        &:last-child{ border-right: none; }
        &.table-block{
          position: relative;
          overflow: hidden;
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }

  .email{
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .field{
    max-width: 50px;
  }
  .fa-check-square{ color: #0fda4e; }
  .fa-square{ color: #b5cebd; }
  a, i{ cursor: pointer; }
}

.slider{
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
  border-radius: 20px;
  background: #ccc;
  position: relative;
  cursor: pointer;
  transition:all .25s ease-in-out;

  &.disabled{ opacity: .4; }
  &:before{
    content: '';
    position: absolute;
    top: 2px;
    left: 3px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #fff;
    transition:all .25s ease-in-out;
    box-shadow: 1px 1px 2px rgba(0,0,0, .25);
  }
  &.active{
    background: #57d1b7;
    &:before{ left: 32px; }
  }
}

.loader{
  position: absolute;
  top:0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;

  div{
    position: absolute;
    top:50%;
    left: 0;
    width: 100%;
    transform: translateY(-50%);
    text-align: center;
  }
}

.sticky{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  height: 30px;
  z-index: 3;
}

.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content {
  display: table-cell;
  vertical-align: middle;
}
.delete-box{
  width: 400px;
  background: #fff;
  margin: 0 auto;
  padding: 20px;
  border-radius: 3px;
  text-align: center;
  color:#444;
  font-weight:600;

  i{ color: #36f18e; }
  span{
    display: block;
    margin: 15px 0 35px;
  }
  .button{
    min-width: 100px;
    margin:0 5px;
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .4s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(15px);
  opacity: 0;
}
.loading {
  text-align: center;
  color: #aaa;
}

@media only screen and (max-width: 430px) {
  .card-holder {
    padding-bottom: 50px;
  }
  .cards {
    .card {
      border: 1px solid #ccc;
      margin: 0 25px;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;

      > div {
        margin-bottom: 3px;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .fas {
          color: #0D79F2;
        }
      }

      .title {
        display: flex;
        align-items: center;
      }

      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
      }
    }
  }
  .slider {
    width: 35px;
    height: 17px;
    &::before {
      width: 15px;
      height: 15px;
      top: 1px;
    }
    &.active {
      &::before {
        left: 18px;
      }
    }
  }
  .fix-footer {
    .row {
      display: flex;
    }
    .per-page {
      width: auto;
      select {
        width: 55px;
      }
      span:nth-child(3) {
        display: none;
      }
    }
    .page-data {
      display: none;
    }
    .pagination {
      display: flex;
      align-items: center;

      select {
        width: 55px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/AdminList.vue